import React, { useEffect, useRef, useState } from "react";
import "../supplierAndManufacturers.scss";
import HeaderTabs from "./HeaderTabs";
import { HeadersTabsValues } from "..";
import { Dropdown } from "react-bootstrap";
import CrossIcon from "../../../icons/cross.icon";
import { useAuth } from "../../../context/Auth";
import { getAPIData } from "../../../../Utils/commonApi";
import useUserDetails from "../../../../hooks/user-details.hook";
import SearchFilterComponent from "../../../Common/SearchFilterComponent/SearchFilterComponent";

export const FILTER_OPTIONS = {
  TYPE: 'Type',
  STATUS: 'Status',
  CATEGORY: 'Categories',
  SUBCATEGORY: 'Subcategories',
  COMPANY: 'Company',
  NONE: 'None'
};

const PageHeader = ({
  isView = false,
  selectedTab = HeadersTabsValues[0],
  setSelectedTab = () => { },
  sortOrder = 0,
  setSortOrder = () => { },
  headersList = [],
  filters = [],
  searchString = '',
  setSearchString = () => { },
  setFilters = () => { },
  getMSPAllSupplierManufacturer = (value) => { },
  onAddClick = () => { },
  onSetOrderData = (value) => { },
  handleKeyPress = () => { },
  handleKeyUp = () => { },
  isSearchDisabled = false
}) => {
  const SearchInput = useRef();
  const { authTokens } = useAuth();
  const [selectedFilterList, setSelectedFilterList] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [lastOpenedFilterId, setLastOpenedFilterId] = useState(null);
  const dropdownRefs = useRef({});
  const { isSaaS } = useUserDetails();

  const filterDataOptions = [
    {
      id: 0,
      title: FILTER_OPTIONS?.TYPE,
      data: [{ id: 0, type: "Supplier" }, { id: 1, type: "Manufacturer" }]
    },
    {
      id: 1,
      title: FILTER_OPTIONS?.STATUS,
      data: [{ id: 0, type: "Active" }, { id: 1, type: "Inactive" }]
    },
    {
      id: 2,
      title: FILTER_OPTIONS?.CATEGORY,
      data: allCategories
    }
  ]

  const searchFilterItem = {
    id: 3,
    title: FILTER_OPTIONS?.COMPANY
  }

  useEffect(() => {
    getCategories();
  }, [])

  async function getCategories() {
    await getAPIData(636, authTokens, {
      ...(isSaaS && {
        optionEnum99: 32
      })
    })
      .then((response) => {
        setAllCategories(convertCategoryObjects(response?.TechnologySpendDetails_List));
      })
      .catch((err) => { });
  }

  function convertCategoryObjects(array) {
    return array?.map((item, index) => ({
      id: item?.ObjectId,
      type: item?.CategoryName
    }));
  }

  useEffect(() => {
    if (lastOpenedFilterId !== null) {
      setTimeout(() => {
        dropdownRefs.current[lastOpenedFilterId]?.click();
        setLastOpenedFilterId(null);
      }, 0);
    }
  }, [lastOpenedFilterId]);

  return (
    <div className="header">
      <SearchFilterComponent
        leftSide={<HeaderTabs tabsList={HeadersTabsValues} selectedTab={selectedTab} setSelectedTab={setSelectedTab} />}
        searchValue={searchString}
        disableSearch={isSearchDisabled}
        searchOnChange={(e) => {
          if (!isSearchDisabled) {
            setSearchString(e?.target?.value);
            handleKeyPress(e);
            let updatedFilters = [...filters];
            const index = updatedFilters.findIndex(item => item?.MSPSupplierFilter_Enum === searchFilterItem?.title);

            if (index !== -1) {
              updatedFilters[index] = {
                MSPSupplierFilter_Enum: searchFilterItem?.title,
                FilterText_List: [e?.target?.value],
              };
            } else {
              updatedFilters.push({
                MSPSupplierFilter_Enum: searchFilterItem?.title,
                FilterText_List: [e?.target?.value],
              });
            }

            setFilters(updatedFilters);
          }
        }}
        handleKeyUp={handleKeyUp}
        searchOnCross={() => {
          setSearchString("");
          let updatedFilters = [...filters];
          const index = updatedFilters.findIndex(item => item?.MSPSupplierFilter_Enum === searchFilterItem?.title);
          updatedFilters.splice(index, 1);
          setFilters(updatedFilters);
          getMSPAllSupplierManufacturer({ filters: updatedFilters });
        }}
        passedRef={SearchInput}
        setRef={() => SearchInput?.current?.focus()}
        showVisibilityComponent={selectedTab?.pageId === 0}
        orderData={headersList}
        setOrderData={onSetOrderData}
        onSortClick={() => {
          const newSortOrder = sortOrder === 0 ? 1 : 0;
          setSortOrder(newSortOrder);
          getMSPAllSupplierManufacturer({ sortOrder: newSortOrder });
        }}
        showLastButton={selectedTab?.pageId === 0 && !isView}
        lastButtonOnClick={onAddClick}
        passedFilterList={filterDataOptions}
        childFilterItem={
          <div>
            {filterDataOptions.map((filterItem) => {
              const isSelected = selectedFilterList.some(option => option?.id === filterItem?.id);
              return (
                <div
                  key={filterItem?.id}
                  className="d-flex align-items-center bg-hover-grey pointer"
                  onClick={(e) => {
                    setSelectedFilterList(prevList => {
                      const newList = [...prevList];
                      const index = newList.findIndex(item => item?.id === filterItem?.id);
                      if (index !== -1) {
                        newList.splice(index, 1);
                      } else {
                        newList.push(filterItem);
                        setLastOpenedFilterId(filterItem?.id); // Set to auto open
                      }
                      return newList;
                    });

                    let updatedFilters = [...filters];
                    const index = updatedFilters?.findIndex(item => item?.MSPSupplierFilter_Enum === filterItem?.title);
                    if (index !== -1) {
                      updatedFilters.splice(index, 1);
                    } else {
                      updatedFilters.push({ MSPSupplierFilter_Enum: filterItem?.title, FilterText_List: [] });
                    }

                    setFilters(updatedFilters);
                    e.target.closest(".transparennt-wrapper-dropdown")?.click();
                  }}
                >
                  {isSelected
                    ? <img alt="" src="/images/msp/dropdown-grey-tick.svg" />
                    : <div style={{ width: '12px' }}></div>
                  }
                  <div className="f-400 f-14 f-grey p-1 ml-2">{filterItem?.title}</div>
                </div>
              );
            })}
          </div>
        }
        childAppliedFilterItem={
          <div className="d-flex align-items-center mt-1">
            {selectedFilterList.map((filterItem) => {
              const index = filters.findIndex(item => item?.MSPSupplierFilter_Enum === filterItem?.title);
              const hasSelectedItems = filters[index]?.FilterText_List?.length > 0;

              return (
                <div
                  key={filterItem?.id}
                  className={`d-flex align-items-center py-1 px-2 mr-2 mb-3 rounded-full applied-filter-item ${hasSelectedItems ? 'has-value' : ''}`}
                >
                  <Dropdown className="transparennt-wrapper-dropdown">
                    <Dropdown.Toggle
                      className="d-flex align-items-center"
                      ref={(el) => {
                        if (el) dropdownRefs.current[filterItem.id] = el;
                      }}
                    >
                      <div className="f-500 f-12 text pointer">{filterItem?.title}</div>
                      {filterItem?.data?.map((filterDataOptionItem) => {
                        const index = filters.findIndex(item => item?.MSPSupplierFilter_Enum === filterItem?.title);
                        const isItemSelected = index !== -1 && filters[index]?.FilterText_List?.includes(filterDataOptionItem?.type);
                        return (
                          isItemSelected && (
                            <div key={filterDataOptionItem?.type} className="f-500 f-12 text rounded-full pointer">: {filterDataOptionItem?.type}</div>
                          )
                        );
                      })}
                    </Dropdown.Toggle>
                    <Dropdown.Menu renderOnMount>
                      {filterItem?.data?.map((filterDataOptionItem) => {
                        const index = filters.findIndex(item => item?.MSPSupplierFilter_Enum === filterItem?.title);
                        const isItemSelected = index !== -1 && filters[index]?.FilterText_List?.includes(filterDataOptionItem?.type);
                        return (
                          <div
                            key={filterDataOptionItem?.type}
                            className="p-1 d-flex align-items-center bg-hover-grey pointer"
                            style={{ width: '200px' }}
                            onClick={(e) => {
                              let updatedFilters = [...filters];
                              const idx = updatedFilters.findIndex(item => item?.MSPSupplierFilter_Enum === filterItem?.title);
                              if (idx !== -1) {
                                updatedFilters[idx] = {
                                  MSPSupplierFilter_Enum: filterItem?.title,
                                  FilterText_List: [filterDataOptionItem?.type],
                                };
                              } else {
                                updatedFilters.push({
                                  MSPSupplierFilter_Enum: filterItem?.title,
                                  FilterText_List: [filterDataOptionItem?.type],
                                });
                              }
                              setFilters(updatedFilters);
                              getMSPAllSupplierManufacturer({ filters: updatedFilters });
                              e.target.closest(".transparennt-wrapper-dropdown")?.click();
                            }}
                          >
                            <img
                              alt=""
                              src="/images/msp/dropdown-grey-tick.svg"
                              className="mx-1"
                              style={{ visibility: isItemSelected ? "visible" : "hidden" }}
                            />
                            <div className="f-400 f-14 f-grey">{filterDataOptionItem?.type}</div>
                          </div>
                        );
                      })}
                    </Dropdown.Menu>
                  </Dropdown>
                  <CrossIcon
                    className="pointer ml-2 cross-icon"
                    width={9}
                    height={9}
                    onClick={() => {
                      const updatedFilters = [...filters];
                      const index = updatedFilters.findIndex(item => item?.MSPSupplierFilter_Enum === filterItem?.title);
                      if (index !== -1) {
                        updatedFilters.splice(index, 1);
                        setFilters(updatedFilters);
                      }

                      const updatedFilters2 = [...selectedFilterList];
                      const index2 = updatedFilters2.findIndex(item => item?.id === filterItem?.id);
                      if (index2 !== -1) {
                        updatedFilters2.splice(index2, 1);
                        setSelectedFilterList(updatedFilters2);
                      }

                      getMSPAllSupplierManufacturer({ filters: updatedFilters });
                    }}
                  />
                </div>
              )
            })
            }
          </div>
        }
        selectedFilterList={selectedFilterList}
        setSelectedFilterList={setSelectedFilterList}
        onResetClick={() => {
          setFilters([]);
          setSelectedFilterList([]);
          getMSPAllSupplierManufacturer({ filters: [] })
        }}
      />
    </div>
  );
};

export default PageHeader;
